export enum SelectionType {
  layout = 1,
  layer = 2,
  group = 3,
  element = 4
}
